import Home from "../../views/administrador/Home";
import addUsers from "../../views/administrador/userAdministration/addUsers";
import administrationsUsers from "../../views/administrador/userAdministration/administrationsUsers";

//----------Ventas-------------
import Routes_Ventas from "../routes/ventas/routes";


//----------Produccion-------------
import RoutesProduccion from "../routes/produccion/routes";


//----------Compras-------------
import routes_compras from "../routes/compras/routes";

//----------Autorizacion-------------
import routes_autorizaciones from "../routes/autorizaciones/routes";

//----------Fracttal-------------
import routes_fracttal from "../routes/fracttal/routes";

//----------Logistica-------------
import routes_logistica from "../routes/logistica/routes";

//----------Bodega-------------
import routes_bodega from "../routes/bodega/routes";



const dashboardRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "pe-7s-home",
    component: Home,
  },
 
  {
    path: "/addUser",
    name: "Add User",
    icon: "pe-7s-add-user",
    component: addUsers,
  },
  {
    path: "/user",
    name: "User Administration",
    icon: "pe-7s-users",
    component: administrationsUsers,
  },
  {
    path: "/manageUser",
    name: "Manage Users",
    icon: "pe-7s-user",
    component: administrationsUsers,
    doNotShow: true,
  },


  //Routes Ventas
  Routes_Ventas[0],
  Routes_Ventas[1], //Entrega Combustible
  Routes_Ventas[2], //Facturas Ffacsa
  

  //Routes Produccion
  RoutesProduccion[0], //Tiempos Muertos
  RoutesProduccion[1], //Liberar Lotes
  RoutesProduccion[2], //Calculo de Resistencias
  RoutesProduccion[3], //Validar Calculo de Resistencias
  RoutesProduccion[4], //Calculo Granulometria
  RoutesProduccion[5], //Certificados de Calidad
  RoutesProduccion[6], //Buzon de Certificados
  RoutesProduccion[7], //Administrar Certificados de Calidad

  //Routes Compras
  routes_compras[0],  
  routes_compras[1], //Solicitud_Compras
  routes_compras[2], //Solicitud Compras articulo ADM
  routes_compras[3], //Solicitud Compras servicio ADM
  routes_compras[4], //Informe status de autorizacion
  routes_compras[5], //Requi Adjunto

  //Routes Autorizaciones
  routes_autorizaciones[0], 
  routes_autorizaciones[1], //BETA 

  //Routes Fracttal
   routes_fracttal[0], 

  //Routes Fracttal
   routes_logistica[0],  // FfactSAP

   //Routes Bodega
   routes_bodega[0],  // Solicitud de traslado
   routes_bodega[1],  // Transferencias de Stock
   routes_bodega[2],  // Inventario
   routes_bodega[3],  // Tags
   routes_bodega[4],  // Informe Inventario
   routes_bodega[5],  // Entrada de Mercancias
   routes_bodega[6],  // Entregas


  {
    path: 3,
    name: "Ventas",
    icon: "pe-7s-cash",
    component: Routes_Ventas
  }, 

  {
    path: 2,
    name: "Produccion",
    icon: "pe-7s-display1",
    component: RoutesProduccion
  }, 
  
  {
    path: 11,
    name: "Compras",
    icon: "pe-7s-cart",
    component: routes_compras
  }, 

  {
    path: 12,
    name: "Autorizaciones",
    icon: "pe-7s-check",
    component: routes_autorizaciones
  },  

  {
    path: 13,
    name: "Fracttal",
    icon: "pe-7s-settings",
    component: routes_fracttal
  },  

  {
    path: 14,
    name: "Logistica",
    icon: "pe-7s-rocket",
    component: routes_logistica
  },  

  {
    path: 15,
    name: "Bodega",
    icon: "pe-7s-box1",
    component: routes_bodega
  },  


  { redirect: true, path: "/", to: "/home", name: "Home" },
];
export default dashboardRoutes;
